import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
  selector: 'app-regatta-race-track',
  imports: [
    MatToolbarModule,
    MatCardModule,
  ],
  templateUrl: './regatta-race-track.component.html',
  styleUrl: './regatta-race-track.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegattaRaceTrackComponent {

}
